import type { GetLocationResponse } from "@/openapi/generated";
import { formatLocationAddressSingleLine } from "@/lib/utils/formatLocationAddress";

const matchSearch = (location: GetLocationResponse, searchValue: string) => {
  if (!searchValue.trim()) return true;

  const q = searchValue.toLowerCase().trim();
  const name = (location.name ?? "").toLowerCase();
  const city = (location.city ?? "").toLowerCase();
  const zip = (location.zipCode ?? "").toLowerCase();
  const description = (location.description ?? "").toLowerCase();
  const address = formatLocationAddressSingleLine(location).toLowerCase();

  return (
    name.includes(q) ||
    city.includes(q) ||
    zip.includes(q) ||
    description.includes(q) ||
    address.includes(q)
  );
};

const matchCity = (location: GetLocationResponse, city: string | null) => {
  if (!city) return true;
  return (location.city ?? "").trim() === city;
};

export type PublicLocationsFilterInput = {
  search: string;
  city: string | null;
};

export function filterPublicLocations(
  locations: GetLocationResponse[] | undefined,
  filters: PublicLocationsFilterInput,
): GetLocationResponse[] {
  if (!locations) return [];

  return locations.filter(
    (location) =>
      matchSearch(location, filters.search) &&
      matchCity(location, filters.city),
  );
}
